module.exports = __webpack_public_path__ + "img/1557614108785844225.cd6b65e8.png";